module.exports = __webpack_public_path__ + "static/img/expressway-text-4.15f089e1.png";